import { render, staticRenderFns } from "./Mailgun.vue?vue&type=template&id=1958b93a"
import script from "./Mailgun.vue?vue&type=script&lang=js"
export * from "./Mailgun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1958b93a')) {
      api.createRecord('1958b93a', component.options)
    } else {
      api.reload('1958b93a', component.options)
    }
    module.hot.accept("./Mailgun.vue?vue&type=template&id=1958b93a", function () {
      api.rerender('1958b93a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/mailDriver/Mailgun.vue"
export default component.exports